import { type AssignmentDto, formatDayFull } from '@betreuung/shared';
import { ResponsiveModal } from '@/components/shared/ResponsiveModal';
import { useAppData } from '@/app/appData';
import { de } from '@/i18n/de';
import { TimelineBody } from './TimelineBody';

export interface TimelineSheetProps {
  dayIndex: number;
  assignments: readonly AssignmentDto[];
  onClose: () => void;
}

/**
 * Second stage of the day detail: the 30-minute grid, as a bottom sheet on
 * phones and a centred dialog on desktop. Both containers scroll, which the
 * 576px column needs on a phone.
 */
export function TimelineSheet({ dayIndex, assignments, onClose }: TimelineSheetProps) {
  const { persons, canWrite } = useAppData();
  // Both copies of the hint change together: one is read aloud, the other is
  // read. Switching only one would tell a screen-reader user to tap to edit
  // while the sighted text says the opposite.
  const hint = canWrite ? de.timeline.hint : de.timeline.hintReadOnly;

  return (
    <ResponsiveModal
      open
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title={formatDayFull(dayIndex)}
      titleAside={<span className="text-hint text-fg-hint">{de.timeline.grid}</span>}
    >
      {/* Not also passed as srDescription: the paragraph below is visible, and
          repeating it as the dialog's description makes a screen reader announce
          the same sentence twice — the rule AssignmentModal already follows. */}
      <p className="pb-2.5 text-hint text-fg-hint">{hint}</p>
      <TimelineBody
        dayIndex={dayIndex}
        assignments={assignments}
        persons={persons}
        onFlowStarted={onClose}
      />
    </ResponsiveModal>
  );
}
